export default __webpack_public_path__ + "static/media/castledown-heavy.0e7909e0.woff2";